import i18n from '../i18n';

export default function translateText(text: string) {
  return (i18n.t(text));
}